import { ProductForm } from '@/components/forms/productForm/productForm';
import TableView from '@/components/products/TableView';
import { CommandInput, Command } from '@/components/shadcn/ui/command';
import { Product } from '@/entities/product';
import { useProduct } from '@/hook/useProduct';
import React, { useEffect, useState } from 'react';

// interface ProductFormData {
//     nome: string;
//     descricao: string; 
//     valor: string;
//     codprod: string;
//     comissao: string;
//   }
  
const ProductPage = () => {
  const [productsPage, setProducts] = useState<Product[]>([]);
  const { productsUse, idToEdit, editProduct, getAllProducts2, setIdToEdit, open, updateProduct, createProduct, setEditProduct, setOpen, selectedProduct, setSelectedProduct,} = useProduct();

  useEffect(()=>{
    setProducts(productsUse);
  },[productsUse]);

  const handleProductSubmit = async (data: any) => {
    const dataProduct = {
      name: data.nome,  
      deploy: Number(data.deploy.includes('.') ? data.deploy.replace('R$', '').replaceAll('.', '').replace(',', '.') : data.deploy.replace('R$', '').replace(',', '.')),
      description: data.descricao,
      commission: Number(data.comissao.includes('.') ? data.comissao.replaceAll('.', '').replace(',', '.') : data.comissao.replace(',', '.')), 
      price: Number(data.valor.includes('.') ? data.valor.replace('R$', '').replaceAll('.', '').replace(',', '.') : data.valor.replace('R$', '').replace(',', '.')), 
    };
  
    try {
      const productCreated = await createProduct(dataProduct);
      if (productCreated) {
        setProducts([...productsPage, productCreated]);
      } else {
        console.error('Erro: O produto criado é nulo.');
      }
    } catch (error) {
      console.error('Erro ao criar o produto:', error);
    }
  };

  const handleProductUpdateSubmit = async (data: any) => {
    const dataProduct = {
      name: data.nome,
      deploy: typeof data.deploy === 'string' ? Number(data.deploy.includes('.') ?  data.deploy.replaceAll('.', '').replace(',','.').replace('R$', '') :  data.deploy.replace(',','.').replace('R$', '')) : data.deploy,
      description: data.descricao,
      commission: typeof data.comissao === 'string' ? Number(data.comissao.includes('.') ?  data.comissao.replaceAll('.', '').replace(',','.') :  data.comissao.replace(',','.')) : data.comissao, 
      price: typeof data.valor === 'string' ? Number(data.valor.includes('.') ?  data.valor.replaceAll('.', '').replace(',','.').replace('R$', '') :  data.valor.replace(',','.').replace('R$', '')) : data.valor, 
    };
    try {
      await updateProduct(idToEdit, dataProduct);
      
    } catch (error) {
      console.error('Erro ao criar o produto:', error);
    }
  };
  
  const alterOpen = (value:boolean) =>{
    setOpen(value);
  };

  const setProduct = (data:any | undefined) => {
    const copyData = {...data};
    setSelectedProduct(copyData);
  };

  const isEdit = (value: boolean) => {
    setEditProduct(value);
  };

  const setId = (id: number) =>{
    setIdToEdit(id);
  };

  const handleProductDelete = (index: number) => {
    const listProducts = [...productsPage];
    listProducts.splice(index, 1);
    setProducts(listProducts);
  };

  return (
    <div className='min-h-screen bg-indigo-200 p-8'>
      <div className='min-h-100 flex flex-col overflow bg-white rounded-md py-4 mx-8 mb-4 '>   
        <div className='flex m-2 justify-between items-center pr-2'>
          <h1 className='m-4 text-md font-medium'>Produtos</h1>
          <div className='flex gap-6'>
            <ProductForm  onProductSubmit={editProduct ? handleProductUpdateSubmit : handleProductSubmit}  isOpen={open} setOpen={alterOpen} setEdit={isEdit} data2={editProduct ? selectedProduct : undefined } editing ={editProduct} setSelectedProduct = {setProduct}/>
            <Command className='flex items-center rounded-lg border-2 p-1 gap-1'>
              <CommandInput placeholder="Pesquisar..."/>
            </Command>
          </div>
        </div>
        <div>
          <TableView
            data={productsPage}
            onProductDelete={handleProductDelete}
            open = {open} 
            setOpen={alterOpen}
            setSelectedProduct={setProduct}
            setEdit={isEdit}
            setIdToEdit = {setId}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductPage;
